<h2 mat-dialog-title>تایید</h2>
<mat-dialog-content>
  <div class="hint-description">
    <span>برای ورود به پروفایل بزرگسال ، کد ارسالی به شماره </span>
    @if (tokenService.userInfo()) {
      <b> {{ tokenService.userInfo()?.mobile }} </b>
    }
    <span>را وارد نمایید</span>
  </div>
  @if (!expiredTime()) {
    <div class="code-input-section">
      <code-input
        #codeInputRef
        dir="ltr"
        [codeLength]="5"
        (codeChanged)="onCodeChanged($event)"
        (codeCompleted)="onCodeCompleted($event)"
      >
      </code-input>
      <div class="hint-box">
        <span>کد ارسال شده را وارد کنید</span>
        <app-countdown-timer (RaiseExpiredTime)="handleExpiredTime($event)" />
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button type="button" class="resend-code" (click)="resendCode()" [disabled]="!expiredTime()">
    ارسال مجدد
  </button>
</mat-dialog-actions>
